import React from 'react';
import './index.css';

const Chip = (props) => {
  return (
    <h6 className="chip">{ props.children }</h6>
  );
};

export default Chip;



// WEBPACK FOOTER //
// ./src/components/chip/index.jsx